<!--
 * @Description: 表格搜索栏
 * @Author: xiawenlong
 * @Date: 2020-12-21 18:06:30
 * @LastEditors: xiawenlong
 * @LastEditTime: 2022-11-15 15:54:41
-->
<template>
  <el-form
    ref="tableSearchForm"
    :model="searchData"
    class="table-search-bar"
    :inline="true"
    @submit.native.prevent
    @keyup.enter.native="onSearch"
  >
    <div class="form">
      <el-form-item v-for="item in searchForm" :key="item.prop" :prop="item.prop">
        <!-- :label="item.label ? item.label + ':' : ''" -->
        <el-cascader
          v-if="item.type === 'treeSelect'"
          v-model="searchData[item.prop]"
          :placeholder="item.placeholder || '请选择' + item.label + '(可搜索)'"
          :props="item.optionProps"
          :show-all-levels="false"
          :options="item.options"
          filterable
          clearable
        ></el-cascader>
        <el-cascader
          v-if="item.type === 'treeAllSelect'"
          v-model="searchData[item.prop]"
          :placeholder="item.placeholder || '请选择' + item.label + '(可搜索)'"
          :props="item.optionProps"
          :show-all-levels="true"
          :options="item.options"
          filterable
          clearable
        ></el-cascader>
        <el-select
          v-if="item.type === 'select'"
          v-model="searchData[item.prop]"
          clearable
          remote
          :remote-method="item.remoteMethod"
          filterable
          :placeholder="item.placeholder || '请选择' + item.label"
          @blur="item.clearMethod && item.clearMethod(searchData[item.prop])"
          @change="item.change && item.change(searchData[item.prop])"
        >
          <el-option
            v-for="option in item.children"
            :key="option.value"
            :value="option.value"
            :label="option.label"
          />
        </el-select>
        <template v-else-if="item.type === 'picker'">
          <!-- <span class="label">{{ item.label }}：</span> -->
          <el-date-picker
            v-model="searchData[item.prop]"
            clearable
            style="width: 100%;"
            type="daterange"
            range-separator="~"
            :start-placeholder="item.placeholder || '开始日期'"
            :end-placeholder="item.placeholder || '结束日期'"
            value-format="yyyy-MM-dd HH:mm:ss"
        /></template>
        <template v-else-if="item.type === 'daypicker'">
          <!-- <span class="label">{{ item.label }}：</span> -->
          <el-date-picker
            v-model="searchData[item.prop]"
            clearable
            style="width: 100%;"
            type="daterange"
            range-separator="~"
            :start-placeholder="item.placeholder || '开始日期'"
            :end-placeholder="item.placeholder || '结束日期'"
            value-format="yyyy-MM-dd"
        /></template>
        <template v-else-if="item.type === 'year'">
          <el-date-picker
            v-model="searchData[item.prop]"
            clearable
            style="width: 100%;"
            type="year"
            :value-format="item.valueFormat || 'yyyy'"
            :placeholder="item.placeholder || '' + item.label"
        /></template>
        <template v-else-if="item.type === 'dayMonth'">
          <el-date-picker
            v-model="searchData[item.prop]"
            clearable
            style="width: 100%;"
            type="date"
            value-format="yyyy-MM-dd"
            :placeholder="item.placeholder || '' + item.label"
        /></template>
        <el-input
          v-if="!item.type || item.type === 'input'"
          v-model="searchData[item.prop]"
          maxlength="64"
          clearable
          :placeholder="item.placeholder || '' + item.label"
        >
          <i v-if="!item.noIcon" slot="prefix" class="el-input__icon el-icon-search"></i
        ></el-input>
      </el-form-item>
      <div
        v-if="searchFormMore.length && !searchFormMoreTextShow"
        class="moreBtn"
        @click="moreBtnShow = !moreBtnShow"
      >
        <i v-if="moreBtnShow" class="el-icon-caret-top"></i>
        <i v-else class="el-icon-caret-bottom"></i>
        <span>{{ moreBtnShow ? '折叠' : '更多' }}</span>
      </div>
      <div class="btns">
        <template v-if="searchForm.length">
          <el-button type="primary" icon="el-icon-search" @click="onSearch">查询</el-button>
          <el-button @click="resetSearchForm">重置</el-button>
        </template>
      </div>
    </div>
    <div
      v-if="
        (searchFormMore.length && moreBtnShow) || (searchFormMore.length && searchFormMoreTextShow)
      "
      class="more-form"
    >
      <el-form-item v-for="item in searchFormMore" :key="item.prop" :prop="item.prop">
        <!-- :label="item.label ? item.label + ':' : ''" -->
        <el-cascader
          v-if="item.type === 'treeSelect'"
          v-model="searchData[item.prop]"
          :placeholder="item.placeholder || '请选择' + item.label + '(可搜索)'"
          :props="item.optionProps"
          :show-all-levels="false"
          :options="item.options"
          filterable
          clearable
        ></el-cascader>
        <el-cascader
          v-if="item.type === 'treeAllSelect'"
          v-model="searchData[item.prop]"
          :placeholder="item.placeholder || '请选择' + item.label + '(可搜索)'"
          :props="item.optionProps"
          :show-all-levels="true"
          :options="item.options"
          filterable
          clearable
        ></el-cascader>
        <el-select
          v-if="item.type === 'select'"
          v-model="searchData[item.prop]"
          clearable
          filterable
          :placeholder="item.placeholder || '请选择' + item.label"
          @change="item.change && item.change(searchData[item.prop])"
          @clear="item.clear && item.clear(searchData[item.prop])"
        >
          <el-option
            v-for="option in item.children"
            :key="option.value"
            :value="option.value"
            :label="option.label"
          />
        </el-select>
        <template v-else-if="item.type === 'picker'">
          <!-- <span class="label">{{ item.label }}：</span> -->
          <el-date-picker
            v-model="searchData[item.prop]"
            clearable
            style="width: 100%; "
            type="daterange"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
        /></template>
        <el-input
          v-if="!item.type || item.type === 'input'"
          v-model="searchData[item.prop]"
          maxlength="64"
          clearable
          :placeholder="item.placeholder || '' + item.label"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i
        ></el-input>
      </el-form-item>
    </div>
  </el-form>
</template>
<script>
export default {
  name: 'TableSearchBar',
  props: {
    searchFormMoreTextShow: {
      type: Boolean,
      default: false,
    },
    searchForm: {
      type: Array,
      default: () => [],
    },
    searchFormMore: {
      type: Array,
      default: () => [],
    },
    btns: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      searchData: {},
      moreBtnShow: false,
    }
  },
  mounted() {
    this.searchForm.forEach(element => {
      if (element.defaultValue || element.defaultValue == 0) {
        this.$set(this.searchData, element.prop, element.defaultValue)
      }
    })
    if (this.searchFormMore.length) {
      this.searchFormMore.forEach(element => {
        if (element.defaultValue || element.defaultValue == 0) {
          this.$set(this.searchData, element.prop, element.defaultValue)
        }
      })
    }
  },
  methods: {
    // 重置搜索条件
    resetSearchForm() {
      this.searchForm.forEach(element => {
        // if (element.defaultValue || element.defaultValue == 0) {
        //   this.$set(this.searchData, element.prop, element.defaultValue)
        // } else {
        this.$set(this.searchData, element.prop, '')
        // }
      })
      if (this.searchFormMore.length) {
        this.searchFormMore.forEach(element => {
          if (element.prop == 'learnLevelId') this.$parent.$parent.levelSelect = []
          this.$set(this.searchData, element.prop, '')
        })
      }
    },
    resetFormItem(prop, str) {
      this.$set(this.searchData, prop, str)
    },
    onSearch() {
      this.$emit('search', this.searchData)
    },
  },
}
</script>
<style lang="scss" scoped>
.table-search-bar {
  overflow: hidden;
  box-sizing: border-box;
  // height: 100px;
  width: 100%;
  background-color: #fff;
  .form {
    // height: 50px;
    // height: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    padding: 10px;
    padding-bottom: 0;
    box-sizing: border-box;
    .moreBtn {
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      width: 50px;
      margin-right: 10px;
      color: #409eff;
      font-size: 14px;
    }
  }
  .more-form {
    height: 50px;
    display: flex;
    align-items: center;
    padding: 0 10px;
    margin-top: -10px;
    box-sizing: border-box;
  }
  /deep/.el-form-item {
    height: 36px;
    line-height: 36px;
    margin-right: 10px;
    margin-bottom: 10px;
    .el-form-item__content {
      height: 36px;
      line-height: 36px;
    }
    .el-input,
    .el-select {
      display: block;
      width: 220px !important;
      height: 36px !important;
      line-height: 36px;
      input {
        border-radius: 2px;
        display: block;
        height: 36px;
        line-height: 36px;
      }
      .el-input__prefix {
        display: flex;
        align-items: center;
        i {
          height: 12px;
          line-height: 1;
        }
      }
      .el-input__suffix {
        display: flex;
        align-items: center;
      }
    }
    .el-date,
    .el-date-editor {
      box-sizing: border-box;
      width: 220px !important;
      border-radius: 2px;
      height: 36px;
      line-height: 36px;
      .el-input__icon {
        height: 12px;
        line-height: normal;
      }
      .el-range-separator {
        line-height: 28px;
      }
    }
    .label {
      font-size: 14px;
      font-weight: 400;
      color: #333333;
    }
  }
  .btns {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    .el-button {
      height: 36px;
      line-height: 34px;
      box-sizing: border-box;
      min-width: 80px;
      width: auto;
      padding: 0 10px;
      margin: 0 10px 0 0;
      &:last-of-type {
        margin-right: 0;
      }
    }
  }
}
</style>
